
'use client';

import React from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Megaphone, CheckCircle, Mail, MessageSquare, TrendingUp } from 'lucide-react';

export default function AdvertisePage() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      {/* Mini Header / Back Button */}
      <div className="border-b px-4 py-3 bg-muted/20">
        <Button asChild variant="ghost" size="sm" className="h-8 text-xs font-bold uppercase">
          <Link href="/">
            <ArrowLeft className="mr-2 h-4 w-4" /> 
            Voltar ao Catálogo
          </Link>
        </Button>
      </div>

      <main className="container mx-auto max-w-4xl px-4 py-12">
        <div className="space-y-12">
          {/* Título Direto */}
          <div className="border-b-4 border-primary pb-4">
            <h1 className="text-3xl font-bold uppercase tracking-tighter flex items-center gap-3">
              <Megaphone className="h-8 w-8 text-primary" />
              Anuncie Conosco
            </h1>
            <p className="text-muted-foreground font-medium uppercase text-xs mt-1">Conecte sua marca a quem busca precisão técnica</p>
          </div>

          <section className="space-y-6">
            <p className="text-lg leading-relaxed">
              O <strong>Peça na Medida</strong> é acessado diariamente por mecânicos, retificadores e técnicos que buscam soluções agora. Sua marca pode estar no momento exato da decisão de compra.
            </p>
          </section>

          {/* Vantagens - Sem frescura */}
          <div className="grid gap-4 md:grid-cols-2">
             <div className="border p-6 bg-muted/5">
                <CheckCircle className="h-6 w-6 text-primary mb-2" />
                <h4 className="font-bold text-sm uppercase">Público Qualificado</h4>
                <p className="text-xs text-muted-foreground">Usuários técnicos que sabem o que estão procurando.</p>
             </div>
             <div className="border p-6 bg-muted/5">
                <TrendingUp className="h-6 w-6 text-primary mb-2" />
                <h4 className="font-bold text-sm uppercase">Alta Conversão</h4>
                <p className="text-xs text-muted-foreground">Exposição no topo ou rodapé do catálogo de peças.</p>
             </div>
          </div>

          {/* Como Funciona */}
          <section className="bg-primary/5 p-8 border rounded-sm">
             <h3 className="font-bold uppercase text-lg mb-4">Informações para Contato</h3>
             <p className="text-sm mb-6">Para anunciar, encaminhe os seguintes dados:</p>
             
             <ul className="text-xs font-bold uppercase space-y-3 mb-8">
                <li className="flex items-center gap-2"><div className="h-1.5 w-1.5 bg-primary rounded-full" /> Nome da Empresa</li>
                <li className="flex items-center gap-2"><div className="h-1.5 w-1.5 bg-primary rounded-full" /> Posição desejada (Topo/Rodapé)</li>
                <li className="flex items-center gap-2"><div className="h-1.5 w-1.5 bg-primary rounded-full" /> Segmento de Atuação</li>
             </ul>

             <div className="grid gap-4 sm:grid-cols-2">
                <Button asChild className="h-12 rounded-sm font-bold shadow-md bg-[#25D366] hover:bg-[#128C7E] text-white">
                   <a href="https://wa.me/5549991702831" target="_blank">
                      <MessageSquare className="mr-2 h-5 w-5" /> WHATSAPP: 49 9 91702831
                   </a>
                </Button>
                <Button asChild variant="default" className="h-12 rounded-sm font-bold shadow-md">
                   <a href="mailto:anuncios@pecanamedida.com.br">
                      <Mail className="mr-2 h-5 w-5" /> anuncios@pecanamedida.com.br
                   </a>
                </Button>
             </div>
          </section>
        </div>
      </main>

      <footer className="mt-auto border-t p-6 text-center text-[10px] text-muted-foreground font-bold uppercase">
         Peça na Medida | Comercial
      </footer>
    </div>
  );
}
